export default {
  user: null,
  isLogged: false,
  token: null,
  tempUser: null
}
